export const MyProjectColors = {
  borderColor: 'border-purple-600',
  backgroundColor: 'bg-purple-600',
  textColor: 'text-purple-800',
};
